import { client } from "./client";

export const URLRoutes = {
  client,
};
